import styled from "styled-components/macro";

import Header from "../../components/header";
import TopBar from "../../components/top_bar";
import SortBar from "../../components/sort_bar";
import CommunityHeader from "../../components/community_header";
import Container from "../../components/container";
import Main from '../../components/main';
import Sidebar from "../../components/sidebar";
import Footer from "../../components/footer";
import {useFeedback} from "../../store/feedback";
import {useQuery} from "../../utils/router";
import Wrapper from "../../components/wrapper";
import {useCommunityStyle} from "../../api/communities";
import {useBaseCommunity} from "../../store/hooks";
import {useSettings} from "../../store";
import {useAltPosts} from "../../api/feed";
import PostList from "../../components/post_list";
import HeaderData from "../../components/header_data";
import Pagination from "../../components/pagination";
import {isPseudoCommunity} from "../../store/communites";
import LegacySortBar from "../../components/legacy/legacy_sort_bar";
import useWindowDimensions from "../../utils/dimensions";

const AltPosts = styled(({className, title, type}) => {

    const community = useBaseCommunity();
    const style = useCommunityStyle(community);

    const page = parseInt(useQuery().page || '1');
    const {expand} = useSettings();
    const {busy, feedbackCh} = useFeedback();
    const {posts} = useAltPosts(feedbackCh, type, 'Win', page);

    const {width} = useWindowDimensions();

    return (
        <div className={className}>
            <HeaderData title={`${title} Posts`} community={community} community_style={style}/>
            <Header>
                {(community !== "TheDonald" || width <= 780) && <TopBar legacyConversion={community === "TheDonald"} page={`${title} Posts`} />}
                {!isPseudoCommunity(community) &&
                    <>
                        <CommunityHeader community={community}/>
                    </>
                }
                {community === "TheDonald" && width > 780 && <LegacySortBar />}
            </Header>
            <SortBar community={community} />
            <Container>
                <Wrapper>
                    <Main>
                        <PostList
                            initialExpand={expand}
                            posts={posts}
                            loading={busy}
                        />
                    </Main>
                    <Pagination path={`/${type}?page=`} has_more page={page} />
                </Wrapper>
                <Sidebar sidebar={style && style.sidebar} community={community} />
            </Container>
            <Footer />
        </div>
    );
})``;

export default AltPosts;
